React = require 'react'
FormFields = require './internal/form-fields'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
{ formatMoney } = require 'app/scripts/lib/format/money'
localizeCount = require 'app/scripts/lib/localize-count'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
moment = require 'moment'

###### DISCLAIMER
#
#  THIS FILE IS USED IN A PLACE THAT CURRENTLY DOES NOT NEED TRANSLATIONS
#  Copied from views/billing/form-sections/summary-component.coffee
#  With some parts removed as they aren't needed for free trial
#
######

module.exports = class extends React.Component
  displayName: 'FreeTrialSummaryComponent'

  formFields: []
  requiredFields: []

  render: t.renderable ->
    {
      monthlyProduct,
      yearlyProduct,
      billingStrategy,
      selectedBillingPlan,
      subTotalCost,
      tax,
      region,
      invitedUsersCount,
    } = @props

    licenseCount = billingStrategy.userCount
    isYearly = selectedBillingPlan.toString() == yearlyProduct.productNumber.toString()
    totalPlusTax = (parseFloat(subTotalCost) + parseFloat(tax || 0)).toFixed(2)
    licenseQuantityCopy = if licenseCount == 1
      "1 person"
    else
      "#{licenseCount} people"


    render = =>
      t.div '.billing-summary.free-trial-billing-summary', ->
        t.hr()
        t.table ->
          t.tbody ->
            t.tr ->
              t.td ->
                t.span '.licences-quantity', ->
                  t.text licenseQuantityCopy
              t.td ->
                t.format 'amount-usd', amount: formatMoney subTotalCost
            t.tr ->
              t.td ->
                if region != null
                  t.format 'sales-tax',
                    region: (if tax then region else '')
                else
                  t.span '.u-form-error', ->
                    t.format 'could-not-calculate-sales-tax'
              t.td ->
                if tax != null
                  t.format 'amount-usd', amount: formatMoney tax
            t.tr ->
              t.td ->
                t.text if isYearly then 'Annual' else 'Monthly'
                t.text ' payment due '
                t.text moment().add(30, 'days').format('MMM. Do, YYYY')
              t.td ->
                t.format 'amount-usd', amount: formatMoney totalPlusTax
            t.tr ->
              t.td ->
                t.text 'Due Today'
              t.td ->
                t.strong '.price', ->
                  t.format 'amount-usd', amount: formatMoney 0
                  t.br()
                  t.span '.small', ->
                    t.text '30-day free trial credit applied'

    t.tag FormFields, {
      @formFields
      @requiredFields
      initialState: {}
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      render
    }